import { Component, OnInit } from '@angular/core';
import { SeoService } from '@app/core/seo/seo.service';
import { SNAPCART_LINKS } from '../snapcart-links';

@Component({
    standalone: false,
    selector: 'app-ws-free-software',
    templateUrl: './ws-free-software.component.html',
    styleUrls: ['./ws-free-software.component.scss']
})
export class WsFreeSoftwareComponent implements OnInit {
    links = SNAPCART_LINKS;

    values = [
        { icon: 'pi pi-desktop', title: 'Runs on your laptop', text: 'Three self-contained jars serve their own web UI and API on localhost. No server to rent, nothing to host.' },
        { icon: 'pi pi-lock', title: 'Your data stays with you', text: 'The database, the UI and the API run on your machine. Only sign-in touches our cloud identity service. Nothing you create leaves your computer.' },
        { icon: 'pi pi-verified', title: 'Real production software', text: 'The same BMS applications ESZES runs as SaaS for its customers, built with the staging profile and licensed to your machine.' }
    ];

    steps = [
        { icon: 'pi pi-envelope', title: 'Request access', text: 'Send us your machine\'s MAC address through the contact form. You receive a licence file and a sign-in account.' },
        { icon: 'pi pi-download', title: 'Download and run', text: 'Unzip the kit, start the bundled MySQL with Docker, run one command per app. First boot takes 20–40 seconds.' },
        { icon: 'pi pi-sign-in', title: 'Sign in and use', text: 'Open localhost:8089 for the catalog, localhost:8090 for orders and localhost:8093 for the books, sign in, and start building your catalog, taking orders and posting vouchers.' }
    ];

    constructor(private seo: SeoService) { }

    ngOnInit(): void {
        this.seo.set({
            title: 'Free business software for all',
            description: 'Run BMS Items, BMS Ecom and BMS Ledger free on your own computer: the Snapcart local edition of the ESZES business suite, licensed per machine, with your data staying on your machine.',
            path: '/free-software'
        });
    }
}
